import(/* webpackMode: "eager" */ "/home/crazysal/sit-a/bd-mobile-next/app/(main)/view-cart/page.tsx");
